export const AssetAllocationKind = {
  SECTOR: 'SECTOR',
  SUPER_SECTOR: 'SUPER_SECTOR',
  CLASS: 'CLASS',
  TYPE: 'TYPE',
  CURRENCY: 'CURRENCY',
  COUNTRY: 'COUNTRY',
} as const;
